import React from "react";
import { FaTasks, FaBookReader } from "react-icons/fa";
import { PiArticleMediumFill } from "react-icons/pi";
import { GiNotebook } from "react-icons/gi";
// import {
//   MdNotificationsActive,
//   MdOutlineDashboardCustomize,
// } from 'react-icons/md';
import { IoMdAnalytics } from "react-icons/io";

import StudentAssignmentPage from "./StudentAssignmentPage";
import StudentEssayPage from "./StudentEssayPage";
import StudentReportPage from "./StudentReportPage";
// import StudentMessagePage from './StudentMessagePage';
import StudentStorytellingPage from "./StudentStorytellingPage";
import StudentDiaryPage from "./StudentDiaryPage";

export const StudentTabs = [
  // {
  //   key: 'Dashboard',
  //   name: 'Dashboard',
  //   link: 'dashboard',
  //   icon: <MdOutlineDashboardCustomize />,
  //   content: <StudentReportPage />,
  // },
  {
    key: "Assignment",
    name: "Assignment",
    link: "assignment",
    icon: <FaTasks />,
    content: <StudentAssignmentPage />,
  },
  {
    key: "Essay",
    name: "Essay",
    link: "essay",
    icon: <PiArticleMediumFill />,
    content: <StudentEssayPage />,
  },
  {
    key: "Storytelling",
    name: "Storytelling",
    link: "storytelling",
    icon: <FaBookReader />,
    content: <StudentStorytellingPage />,
  },
  {
    key: "Diary",
    name: "Diary",
    link: "diary",
    icon: <GiNotebook />,
    content: <StudentDiaryPage />,
  },
  {
    key: "Reports",
    name: "Reports",
    link: "reports",
    icon: <IoMdAnalytics />,
    content: <StudentReportPage />,
  },
  // {
  //   key: 'Message',
  //   name: 'Message',
  //   link: 'message',
  //   icon: <MdNotificationsActive />,
  //   content: <StudentMessagePage />,
  // },
];
